import React from "react";
import { SwitchTransition, CSSTransition } from "react-transition-group";
const Alert = ({ kind, children, className = "", key = "" }) => {
    const none = kind === "none" || !children;
    return (React.createElement(SwitchTransition, null,
        React.createElement(CSSTransition, { key: typeof children === "string"
                ? `${kind}|${children}|${className}|${key}`
                : `${kind}|${className}|${key}`, timeout: {
                enter: none ? 0 : 500,
                exit: none ? 0 : 450
            }, classNames: "fade" },
            React.createElement("div", { className: `alert ${kind} ${className}`, style: {
                    animationDuration: none ? "0" : "500ms",
                    display: none ? "none" : "inherit"
                } }, children))));
};
export default Alert;
